export default {
  ON: 'on',
  OFF: 'off',
  AUTO: 'auto',
};



// WEBPACK FOOTER //
// ./src/enums/dark-mode-states.js